<mat-card class="card-linnks margin-linnks">
  <mat-card-title>
    {{ title }}
    <mat-card-subtitle>
      {{ subtitle }}. Período selecionado{{' '+
      this.dataIniSearch.substring(8,10)+'/'+this.dataIniSearch.substring(5,7)+'/'+this.dataIniSearch.substring(0,4)}}
      à {{' '+ this.dataFinSearch.substring(8,10)
      +'/'+this.dataFinSearch.substring(5,7)+'/'+this.dataFinSearch.substring(0,4)}}
    </mat-card-subtitle>
  </mat-card-title>




  <div>
    <mat-card-content>
      <div class="box-content pt-2">

        <div class="header-box">
          <div class="header-box-content">
            <h3 class="title-card"> &nbsp;</h3>
            <div class="actions-card">
              <button type="button" class="btn btn-xs btn-link" (click)="dt2.exportCSV()" matTooltip="Exportar Excel"
                matTooltipPosition="above"><i class="far fa-file-excel excel"></i> </button>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>

        <p-table class="table-system" #dt2 [columns]="colsListaGetnetAssinaturas" [value]="listaGetnetAssinaturas"
          [rows]="rows" [paginator]="true" [totalRecords]="listaGetnetAssinaturas.length" (onFilter)="onFilter($event)"
          [pageLinks]="pageLinks" [rowsPerPageOptions]="rowsPerPage" selectionMode="single" [style]="{'width':'100%'}">
          <ng-template pTemplate="header">
            <tr>

              <th class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'subscriptionId'">
                  <span class="text-overflow-dynamic-ellipsis">ASSINATURA ID <p-sortIcon [field]="'subscriptionId'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'saleId', 'contains')">
              </th>

              <th class="text-left" style="width: 15%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'nomeCompleto'">
                  <span class="text-overflow-dynamic-ellipsis">NOME CLIENTE <p-sortIcon [field]="'nomeCompleto'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'nomeCompleto', 'contains')">
              </th>

              <th class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'createDate'">
                  <span class="text-overflow-dynamic-ellipsis">DT CRIAÇÃO ASS. <p-sortIcon [field]="'createDate'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'createDate', 'contains')">
              </th>
              <th class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'endDate'">
                  <span class="text-overflow-dynamic-ellipsis">DT FINAL ASS. <p-sortIcon [field]="'endDate'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'endDate', 'contains')">
              </th>

              <th class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'installmentStartDate'">
                  <span class="text-overflow-dynamic-ellipsis">DT INICIO PAG. <p-sortIcon
                      [field]="'installmentStartDate'"></p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'installmentStartDate', 'contains')">
              </th>

              <th class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'endDate'">
                  <span class="text-overflow-dynamic-ellipsis">DT FINAL PAG. <p-sortIcon [field]="'endDate'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'endDate', 'contains')">
              </th>

              <th class="text-center" style="width: 6%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'statusPt'">
                  <span class="text-overflow-dynamic-ellipsis">STATUS <p-sortIcon [field]="'statusPt'"></p-sortIcon>
                    </span>
                </span>
                <p-multiSelect class="type-p-mult" [options]="opcoesComboStatus" defaultLabel="Selecione"
                  [filter]="false" (onChange)="dt2.filter($event.value, 'statusPt', 'in')"></p-multiSelect>
              </th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>

              <td class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.subscriptionId}}">{{rowData.subscriptionId }}</span>
                </span>
              </td>
              <td class="text-left" style="width: 15%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.nomeCompleto}}">{{rowData.nomeCompleto }}</span>
                </span>
              </td>
              <td class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.createDate}}">{{rowData.createDate}}</span>
                </span>
              </td>
              <td class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.endDate}}">{{rowData.endDate}}</span>
                </span>
              </td>
              <td class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.installmentStartDate}}">{{rowData.installmentStartDate }}</span>
                </span>
              </td>

              <td class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.endDate}}">{{rowData.endDate }}</span>
                </span>
              </td>

              <td class="text-left" style="width: 6%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis" (click)="showModalInformacoes(rowData)"
                    matTooltip="{{rowData.statusPt}}">{{rowData.statusPt }}</span>
                </span>
              </td>


            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-rowData>
            <tr>
              <td [attr.colspan]="7" class="spaced-alert">
                <div class="alert alert-xs alert-primary d-inline" role="alert">
                  <i class="fas fa-info-circle"></i> Nenhum Registro Encontrado!
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>


      </div>

      <div class="ui-g">
        <div class="ui-g-12">

        </div>
      </div>


      <!--Inicio Modal INFORMACOES-->
      <p-dialog header="INFORMAÇÕES" [(visible)]="modalInformacoes" [style]="{width: '850px'}" [modal]="true"
        styleClass="modal-scroll" [responsive]="true" appendTo="body" [closable]="true">

        <!-- modalConsultor -->
        <div *ngIf="modalInformacoes">

          <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="tabChange($event)">
            <mat-tab label="INFORMAÇÕES">

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>ASSINATURA ID</label>
                  <input type="text" class="form-control text-left" readonly="true"
                    value="{{getNetAssinatura.subscriptionId}}" [(ngModel)]="getNetAssinatura.subscriptionId" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>NOME CLIENTE</label>
                  <input type="text" class="form-control text-left" readonly="true" value="{{nomeCompleto}}"
                    [(ngModel)]="nomeCompleto" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>DATA CRIAÇÃO DA ASSINATURA</label>
                  <input type="text" class="form-control text-left" readonly="true"
                    value="{{getNetAssinatura.createDatePt}}" [(ngModel)]="getNetAssinatura.createDatePt" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>DATA FINAL DA ASSINATURA</label>
                  <input type="text" class="form-control text-left" readonly="true"
                    value="{{getNetAssinatura.endDatePt}}" [(ngModel)]="getNetAssinatura.endDatePt" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>DATA INICIO DO PAGAMENTO</label>
                  <input type="text" class="form-control text-left" readonly="true"
                    value="{{getNetAssinatura.installmentStartDatePt}}"
                    [(ngModel)]="getNetAssinatura.installmentStartDatePt" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>DATA FINAL DE PAGAMENTO</label>
                  <input type="text" class="form-control text-left" readonly="true"
                    value="{{getNetAssinatura.endDatePt}}" [(ngModel)]="getNetAssinatura.endDatePt" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-sm-12">
                  <label>STATUS</label>
                  <input type="text" class="form-control text-left" readonly="true"
                    value="{{getNetAssinatura.statusPt}}" [(ngModel)]="getNetAssinatura.statusPt" />
                </div>
              </div>

            </mat-tab>


          </mat-tab-group>



          <div class="ui-g" style="position:fixed; right: 25px; bottom: 30px;">
            <div class="ui-g-12">

            </div>
          </div>

        </div>


        <p-footer>
          <button type="button" class="btn btn-secondary" (click)="modalInformacoes=false;"><i class="fas fa-undo"></i>
            Cancelar</button>

        </p-footer>
      </p-dialog>
      <!--Final Modal INFORMACOES-->




      <!-- Modal Alterar Período -->
      <p-dialog header="Alterar Período" [(visible)]="modalPeriodo" [style]="{width: '400px'}" [modal]="true"
        class="modal-initial" [responsive]="true" [contentStyle]="{'overflow':'visible'}" appendTo="body"
        [closable]="true">
        <div *ngIf="modalPeriodo">
          <div class="form-row">
            <div class="form-group col-sm-6">
              <label>Data Inicial </label>
              <p-calendar class="type-p-calendar" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
                [defaultDate]="dataIni" [(ngModel)]="dataIni" dateFormat="dd/mm/yy" ></p-calendar>
            </div>
            <div class="form-group col-sm-6">
              <label>Data Final </label>
              <p-calendar class="type-p-calendar" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
                [defaultDate]="dataFin" [(ngModel)]="dataFin" dateFormat="dd/mm/yy" ></p-calendar>
            </div>
          </div>
        </div>
        <div class="ui-g" style="position: fixed; right: 0; bottom: 2px; max-width: 555px;">
          <div class="ui-g-12">

          </div>
        </div>
        <p-footer>
          <button type="button" class="btn btn-secondary" (click)='modalPeriodo=false;'><i class="fas fa-undo"></i>
            Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="periodoChange();"><i class="fas fa-check"></i>
            Alterar</button>
        </p-footer>
      </p-dialog>
      <!-- Modal Alterar Período -->


    </mat-card-content>
  </div>

</mat-card>